import React, { useRef } from 'react';
import { Button, type ButtonProps } from '@roger/ui-components';

/**
 * A button that picks one PDF. The file input stays hidden but labelled, so
 * the visible control is an ordinary button with a plain verb on it.
 */
const PdfFileButton: React.FC<{
  inputLabel: string;
  disabled?: boolean;
  variant?: ButtonProps['variant'];
  onFile: (file: File) => void;
  children: React.ReactNode;
}> = ({ inputLabel, disabled, variant = 'outline', onFile, children }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <Button
        type='button'
        variant={variant}
        size='sm'
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        {children}
      </Button>
      <input
        ref={inputRef}
        type='file'
        accept='application/pdf'
        aria-label={inputLabel}
        disabled={disabled}
        className='hidden'
        onChange={event => {
          const file = event.target.files?.[0];
          event.target.value = '';
          if (file) onFile(file);
        }}
      />
    </>
  );
};

export default PdfFileButton;
